import { track } from '~/lib/posthog';

/** The Mac app download: the landing's own link, which always serves the newest release. */
export const MAC_APP_DOWNLOAD_PATH = '/download/mac';

/**
 * Whether to offer the Mac app: on a Mac, and never inside the Mac app itself, which adds "DeckDesktop"
 * to its user agent. An iPad also calls itself "Macintosh", but it has a touch screen and a Mac does not.
 */
export function offersMacApp(): boolean {
  if (typeof navigator === 'undefined') return false;
  const agent = navigator.userAgent;
  return agent.includes('Macintosh') && !agent.includes('DeckDesktop') && navigator.maxTouchPoints <= 1;
}

/** Starts the download. The link answers with the file itself, so the page stays where it is. */
export function downloadMacApp(from: string): void {
  track('mac_app_download', { from });
  window.location.assign(MAC_APP_DOWNLOAD_PATH);
}
